/** Roles que pueden crear y editar cursos. */
export const COURSE_MANAGE_TYPE_USERS = ['director', 'desarrollador'];

export const canManageCourses = (typeUser) => (
    COURSE_MANAGE_TYPE_USERS.includes(typeUser)
);
